<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "SkeletonInternetOffer"
})
</script>

<template>
    <div class="position-relative mb-1">
        <!-- Header avec bouton retour -->
        <div class="ob1-skeleton py-1">
            <div class="ob1-skeleton-gray2 back-button"></div>
        </div>

        <!-- Bandeau bg-primary3 -->
        <div class="bg-primary3 banner"></div>

        <div class="bg-white text-black px-2 pb-1 mt-5 content-overlay">
            <div class="ob1-skeleton mb-1">
                <div class="row">
                    <!-- Tag + Image -->
                    <div class="col-12 d-flex justify-content-between position-relative">
                        <!-- Tag -->
                        <div class="ob1-skeleton-gray2 tag-skeleton align-self-start"></div>
                        <!-- Image produit -->
                        <div class="ob1-skeleton-white product-image-skeleton"></div>
                    </div>
                    <!-- Titre + Prix -->
                    <div class="d-flex mt-1 justify-content-between w-100">
                        <!-- Titre -->
                        <div class="w-75 me-2">
                            <div class="ob1-skeleton-white ob1-skeleton-margin title-skeleton"></div>
                            <div class="ob1-skeleton-white ob1-skeleton-margin sub-title-skeleton "></div>
                        </div>

                        <!-- Prix -->
                        <div class="w-25 d-flex flex-column align-items-end">
                            <div class="ob1-skeleton-white price-skeleton"></div>
                            <div class="ob1-skeleton-white ob1-skeleton-margin price-info-skeleton"></div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="separator separator--gray4 w-100">

            <!-- Features list -->
            <div class="ob1-skeleton my-1">
                <div class="d-flex my-1 align-items-start mb-1">
                    <div class="ob1-skeleton-white feature-icon me-1"></div>
                    <div class="d-flex flex-column w-100">
                        <div class="ob1-skeleton-white feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-link"></div>
                    </div>
                </div>
                <div class="d-flex my-1 align-items-start mb-1">
                    <div class="ob1-skeleton-white feature-icon me-1"></div>
                    <div class="d-flex flex-column w-100">
                        <div class="ob1-skeleton-white feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-link"></div>
                    </div>
                </div>
                <div class="d-flex my-1 align-items-start mb-1">
                    <div class="ob1-skeleton-white feature-icon me-1"></div>
                    <div class="d-flex flex-column w-100">
                        <div class="ob1-skeleton-white feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-link"></div>
                    </div>
                </div>
                <div class="d-flex my-1 align-items-start mb-1">
                    <div class="ob1-skeleton-white feature-icon me-1"></div>
                    <div class="d-flex flex-column w-100">
                        <div class="ob1-skeleton-white feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-link"></div>
                    </div>
                </div>
                <div class="d-flex my-1 align-items-start mb-1">
                    <div class="ob1-skeleton-white feature-icon me-1"></div>
                    <div class="d-flex flex-column w-100">
                        <div class="ob1-skeleton-white feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-text"></div>
                        <div class="ob1-skeleton-white ob1-skeleton-margin feature-link"></div>
                    </div>
                </div>
            </div>

            <hr class="separator separator--gray4 w-100">

            <div class="ob1-skeleton my-1">
                <div class="ob1-skeleton-white back-button"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.back-button {
    width: 80px;
    height: 20px;
}

.banner {
    height: 180px;
    width: 100%;
    position: absolute;
    top: 50px;
    z-index: 1;

    @media (min-width: 736px) {
        width: calc(100% + 3.125%);
        left: -1.5625%;
    }
    @media (min-width: 960px) {
        width: calc(100% + 6.25%);
        left: -3.125%;
    }
    @media (min-width: 1440px) {
        width: calc(100% + 90px);
        left: -45px;
    }
}

.content-overlay {
    position:relative;
    z-index: 2;
}

.tag-skeleton {
    width: 120px;
    height: 20px;
}

.title-skeleton {
    width: 60%;
    height: 50px;
}

.sub-title-skeleton {
    width: 30%;
    height: 20px;
}

.product-image-skeleton {
    width: 100px;
    height: 100px;
    position: absolute;
    right: 14px;
    top: -80px;
}

.price-skeleton {
    width: 60%;
    height: 50px;
}

.price-info-skeleton {
    width: 40%;
    height: 20px;
}

.description-skeleton {
    margin: 15px 20px;
    height: 16px;
}

.feature-icon {
    width: 24px;
    height: 24px;
}

.feature-text {
    height: 24px;
    width: 60%;
}
.feature-link {
    height: 24px;
    width: 30%;
}
</style>
